// import React, { useState, useRef, useEffect, useCallback } from "react";
// import "../DppScheduling/DppScheduling.css";
// import InputComponent from "../TestScheduling/Input-testscheduling";
// import { useLocation, useNavigate } from "react-router-dom";
// import { IoCheckmarkCircle, IoCloseCircle, IoChevronDownCircleOutline } from "react-icons/io5";
// import { FULL_API_BASE_URL } from "../../../Config/Config";

// const DPPApproval = ({ setMessageBox, setIsMessageBoxVisible, setActiveImg, dataClient }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const dashboardData = location.state || {};

//   // ── User info from dataClient (same pattern as DPPScheduleEdit) ──
//   const reviewedBy =
//     dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";

//   // ── Question Paper fields from dashboardData ──
//   const quesPaperId    = dashboardData.ques_paper_id    || dashboardData.dpp_schedule_id || null;
//   const selectedCourseName              = dashboardData.course          || "";
//   const selectedQuestionPaperSubjects   = dashboardData.subject_name    || "";
//   const selectedChapterName             = dashboardData.chapter_list    || "";
//   const selectedQuestionPaperName       = dashboardData.ques_paper_name || "";
//   const selectedQuestionPaperDescription= dashboardData.ques_paper_description || "";
//   const selectedQuestionPaperCreatedBy  = dashboardData.scheduled_by    || "";

//   // ── Data from API ──
//   const [coursePlans, setCoursePlans]         = useState([]);
//   const [instructionsHtml, setInstructionsHtml] = useState("");
//   const [existingReview, setExistingReview]   = useState(null); // { is_approved, comments }
//   const [loading, setLoading]                 = useState(true);
//   const [apiError, setApiError]               = useState("");

//   // ── Reject modal ──
//   const [rejectModal, setRejectModal]   = useState({ visible: false });
//   const [rejectComment, setRejectComment] = useState("");

//   // ── API submit state ──
//   const [submitting, setSubmitting] = useState(false);
//   const [submitError, setSubmitError] = useState("");

//   // ─────────────────────────────────────────────────────────────────────────
//   // FETCH: get-dpp-schedule-by-ques-paper-id-review
//   // ─────────────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (!quesPaperId) { setLoading(false); return; }
//     const fetchSchedules = async () => {
//       try {
//         setLoading(true);
//         const accessToken = localStorage.getItem("other");
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-dpp-schedule-by-ques-paper-id-review/?ques_paper_id=${quesPaperId}`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               Accept: "application/json",
//             },
//           }
//         );
//         if (!response.ok) throw new Error(`HTTP ${response.status}`);
//         const json = await response.json();

//         const schedules = json?.data?.schedule || [];
//         const reviews   = json?.data?.reviews  || [];

//         // Build folder name from dpp_level1_id > dpp_level2_id > dpp_level3_id
//         // (using their names if available, falling back to chapter_names / topic_names)
//         const plans = schedules.map((s) => {
//           const folderParts = [s.dpp_level1_name, s.dpp_level2_name, s.dpp_level3_name].filter(Boolean);
//           const folderName = folderParts.join(" > ");
//           return {
//             dpp_schedule_id: s.dpp_schedule_id,
//             dpp_name:    s.dpp_name    || "",
//             description: s.dpp_desc   || "",
//             start_date:  s.dpp_window_start || "",
//             term_date:   s.dpp_term_date    || "",
//             folder_name: folderName,
//             instructions_html: s.instructions_html || "",
//           };
//         });

//         setCoursePlans(plans);

//         // Use instructions from first schedule
//         if (schedules.length > 0) {
//           setInstructionsHtml(schedules[0].instructions_html || "");
//         }

//         // Latest review (last item)
//         if (reviews.length > 0) {
//           const latest = reviews[reviews.length - 1];
//           setExistingReview(latest);
//         }
//       } catch (err) {
//         console.error("Error fetching DPP schedules:", err);
//         setApiError("Failed to load schedule data.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchSchedules();
//   }, [quesPaperId]);

//   // ─────────────────────────────────────────────────────────────────────────
//   // SUBMIT: create-dpp-schedule-approval
//   // ─────────────────────────────────────────────────────────────────────────
//   const submitApproval = async (isApproved, comments = "") => {
//     try {
//       setSubmitting(true);
//       setSubmitError("");
//       const accessToken = localStorage.getItem("other");
//       const payload = {
//         ques_paper_id: Number(quesPaperId),
//         reviewed_by:   reviewedBy,
//         is_approved:   isApproved,
//         comments:      comments,
//       };
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/create-dpp-schedule-approval/`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//             Accept: "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );
//       if (!response.ok) throw new Error(`HTTP ${response.status}`);
//       // Update local review state so buttons disable/enable immediately
//       setExistingReview({ is_approved: isApproved, comments });
//       // Navigate back to dashboard on success
//       navigate("/dpp_approval_dashboard");
//     } catch (err) {
//       console.error("Error submitting approval:", err);
//       setSubmitError("Failed to submit. Please try again.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleApprove = () => {
//     submitApproval(true, "");
//   };

//   const openRejectModal = () => {
//     setRejectComment("");
//     setRejectModal({ visible: true });
//   };

//   const handleRejectConfirm = () => {
//     setRejectModal({ visible: false });
//     submitApproval(false, rejectComment);
//   };

//   const handleRejectCancel = () => {
//     setRejectModal({ visible: false });
//     setRejectComment("");
//   };

//   // Current decision derived from latest review
//   // null = never reviewed, true = approved, false = rejected
//   const currentDecision = existingReview != null ? existingReview.is_approved : null;

//   // Approve disabled when already approved; Reject disabled when already rejected
//   const isApproveDisabled = submitting || currentDecision === true;
//   const isRejectDisabled  = submitting || currentDecision === false;

//   // Show comments field only when last review is rejection with a comment
//   const showCommentsField =
//     existingReview &&
//     existingReview.is_approved === false &&
//     existingReview.comments;

//   return (
//     <>
//       <div className="Leftmargin-Main-DIV">

//         {/* ── Page Header: APPROVE  REJECT  CANCEL ── */}
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px", width: "98%" }}>
//           <div style={{ fontSize: "30px", color: "var(--DppPlanNameText)", fontWeight: "400", whiteSpace: "nowrap" }}>
//             DPP Approval
//           </div>
//           <div>
//             <div className="row-cs-uni">
//               {/* APPROVE */}
//               <button
//                 className="create-test-section-btn"
//                 style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040", opacity: isApproveDisabled ? 0.45 : 1, cursor: isApproveDisabled ? "not-allowed" : "pointer" }}
//                 onClick={handleApprove}
//                 disabled={isApproveDisabled}
//               >
//                 APPROVE
//               </button>
//               {/* REJECT */}
//               <button
//                 className="create-test-section-btn"
//                 style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040", opacity: isRejectDisabled ? 0.45 : 1, cursor: isRejectDisabled ? "not-allowed" : "pointer" }}
//                 onClick={openRejectModal}
//                 disabled={isRejectDisabled}
//               >
//                 REJECT
//               </button>
//               {/* CANCEL */}
//               <button
//                 className="create-test-section-btn"
//                 style={{ marginRight: "0px", boxShadow: "0px 4px 4px 0px #00000040" }}
//                 onClick={() => navigate("/dpp_approval_dashboard")}
//                 disabled={submitting}
//               >
//                 CANCEL
//               </button>
//             </div>
//           </div>
//         </div>

//         {submitError && (
//           <div style={{ color: "#C62828", fontSize: "13px", marginBottom: "12px", width: "98%" }}>
//             {submitError}
//           </div>
//         )}

//         {/* ── QUESTION PAPER DETAIL ── */}
//         <div className="Header-1-C424342">QUESTION PAPER DETAIL</div>
//         <div className="Body-1-C424342">
//           <div className="row-cs">
//             <div className="col-cs"><InputComponent label="Select Course" style={{ width: "97%" }} value={selectedCourseName} isRequired={false} disable={true} /></div>
//             <div className="col-cs"><InputComponent label="Select Subject" style={{ width: "97%" }} value={selectedQuestionPaperSubjects} isRequired={false} disable={true} /></div>
//             <div className="col-cs"><InputComponent label="Select Chapter (Optional)" style={{ width: "97%" }} value={selectedChapterName} isRequired={false} disable={true} /></div>
//           </div>
//           <div className="row-cs">
//             <div className="col-cs"><InputComponent label="Select Topic (Optional)" style={{ width: "97%" }} value={dashboardData.topic || ""} isRequired={false} disable={true} /></div>
//             <div className="col-cs"><InputComponent label="Question Paper Name" style={{ width: "97%" }} value={selectedQuestionPaperName} isRequired={false} disable={true} /></div>
//             <div className="col-cs"><InputComponent label="Question Paper Description" style={{ width: "97%" }} value={selectedQuestionPaperDescription} isRequired={false} disable={true} /></div>
//           </div>
//           <div className="row-cs">
//             <div className="col-cs"><InputComponent label="Question Paper Created By" style={{ width: "97%" }} value={selectedQuestionPaperCreatedBy} isRequired={false} disable={true} /></div>
//             <div className="col-cs"><InputComponent label="Question Paper Subjects" style={{ width: "97%" }} value={selectedQuestionPaperSubjects} isRequired={false} disable={true} /></div>
//             <div className="col-cs" />
//           </div>

//           {/* Instructions — always shown, blank when empty */}
//           <div style={{ marginRight: "15px", marginBottom: "20px" }}>
//             <div style={{ fontSize: "13px", color: "var(--DppLabelText)", marginBottom: "6px", fontWeight: "500" }}>Instructions</div>
//             <div
//               style={{ padding: "12px 14px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", backgroundColor: "var(--DppCardBackgroundCollapsed)", fontSize: "14px", color: "var(--DppPlanNameText)", minHeight: "200px", opacity: 0.85, boxSizing: "border-box" }}
//               dangerouslySetInnerHTML={{ __html: instructionsHtml }}
//             />
//           </div>

//           {/* Comments field — only shown when last review is rejected AND has comments */}
//           {showCommentsField && (
//             <div style={{ marginRight: "15px", marginBottom: "20px" }}>
//               <div style={{ fontSize: "13px", color: "var(--DppLabelText)", marginBottom: "6px", fontWeight: "500" }}>
//                 Previous Rejection Comments
//               </div>
//               <div
//                 style={{ padding: "12px 14px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", backgroundColor: "var(--DppCardBackgroundCollapsed)", fontSize: "14px", color: "var(--DppPlanNameText)", minHeight: "48px", opacity: 0.85, boxSizing: "border-box" }}
//               >
//                 {existingReview.comments}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* ── COURSE PLAN DETAILS TABLE ── */}
//         <div style={{ marginTop: "30px", width: "98%", marginBottom: "30px" }}>
//           <div style={{ fontSize: "15px", fontWeight: "600", color: "var(--DppPlanNameText)", marginBottom: "16px" }}>
//             COURSE PLAN DETAILS
//           </div>

//           {loading ? (
//             <div style={{ padding: "40px", textAlign: "center", color: "var(--DppLabelText)", fontSize: "14px" }}>
//               Loading schedules...
//             </div>
//           ) : apiError ? (
//             <div style={{ padding: "20px", color: "#C62828", fontSize: "14px" }}>{apiError}</div>
//           ) : (
//             <div style={{ border: "1px solid var(--DppCardBorder)", borderRadius: "8px", overflow: "visible", boxShadow: "0px 2px 4px rgba(0,0,0,0.08)" }}>
//               <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                 <thead>
//                   <tr style={{ backgroundColor: "var(--DppCardHeaderExpanded)" }}>
//                     {["DPP Name", "Description", "Start Date", "Term Date", "Folder Name"].map((heading) => (
//                       <th key={heading} style={{ padding: "12px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "var(--DppLabelText)", whiteSpace: "nowrap", borderBottom: "1px solid var(--DppCardHeaderBorder)" }}>
//                         {heading}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {coursePlans.map((plan, idx) => (
//                     <tr
//                       key={plan.dpp_schedule_id}
//                       style={{ backgroundColor: idx % 2 === 0 ? "var(--DppCardBackground)" : "var(--DppCardBackgroundCollapsed)", borderBottom: "1px solid var(--DppCardBorder)" }}
//                     >
//                       <td style={{ padding: "14px 16px", fontSize: "14px", color: "var(--DppPlanNameText)", fontWeight: "500", maxWidth: "180px" }}>{plan.dpp_name}</td>
//                       <td style={{ padding: "14px 16px", fontSize: "13px", color: "var(--DppValueText)", maxWidth: "200px" }}>{plan.description}</td>
//                       <td style={{ padding: "14px 16px", fontSize: "13px", color: "var(--DppValueText)", whiteSpace: "nowrap" }}>{plan.start_date}</td>
//                       <td style={{ padding: "14px 16px", fontSize: "13px", color: "var(--DppValueText)", whiteSpace: "nowrap" }}>{plan.term_date}</td>
//                       <td style={{ padding: "14px 16px", fontSize: "13px", color: "var(--DppValueText)" }}>{plan.folder_name}</td>
//                     </tr>
//                   ))}
//                   {coursePlans.length === 0 && (
//                     <tr>
//                       <td colSpan={5} style={{ padding: "40px", textAlign: "center", color: "var(--DppLabelText)", fontSize: "14px" }}>
//                         No course plan schedules found.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* ── Reject modal ── */}
//       {rejectModal.visible && (
//         <div
//           style={{ position: "fixed", inset: 0, zIndex: 99999, backgroundColor: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center" }}
//           onMouseDown={(e) => { if (e.target === e.currentTarget) handleRejectCancel(); }}
//         >
//           <div style={{ backgroundColor: "#fff", borderRadius: "10px", padding: "28px 32px", width: "440px", boxShadow: "0 8px 32px rgba(0,0,0,0.22)" }}>
//             <div style={{ marginBottom: "16px" }}>
//               <h3 style={{ margin: 0, fontSize: "17px", fontWeight: "600", color: "#2F2E40" }}>Comments</h3>
//             </div>
//             <p style={{ margin: "0 0 12px", fontSize: "13px", color: "#6A6A7A" }}>
//               Please provide a reason for rejection. This will be recorded against the schedule.
//             </p>
//             <textarea
//               autoFocus
//               placeholder="Enter reason for rejection..."
//               value={rejectComment}
//               onChange={(e) => setRejectComment(e.target.value)}
//               rows={4}
//               style={{ width: "100%", padding: "10px 12px", border: "1px solid #D0D0E0", borderRadius: "6px", fontSize: "14px", color: "#2F2E40", resize: "vertical", outline: "none", boxSizing: "border-box", fontFamily: "inherit" }}
//               onFocus={(e) => (e.currentTarget.style.borderColor = "#337AB7")}
//               onBlur={(e) => (e.currentTarget.style.borderColor = "#D0D0E0")}
//             />
//             <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
//               <button
//                 onClick={handleRejectCancel}
//                 style={{ padding: "8px 20px", border: "1px solid #CCCCDD", borderRadius: "6px", backgroundColor: "#fff", color: "#2F2E40", fontSize: "14px", fontWeight: "500", cursor: "pointer" }}
//                 onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F5F5F8")}
//                 onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleRejectConfirm}
//                 disabled={!rejectComment.trim()}
//                 style={{ padding: "8px 20px", border: "1px solid #CCCCDD", borderRadius: "6px", backgroundColor: "#fff", color: "#2F2E40", fontSize: "14px", fontWeight: "500", cursor: rejectComment.trim() ? "pointer" : "not-allowed", opacity: rejectComment.trim() ? 1 : 0.5 }}
//                 onMouseEnter={(e) => { if (rejectComment.trim()) e.currentTarget.style.backgroundColor = "#F5F5F8"; }}
//                 onMouseLeave={(e) => { if (rejectComment.trim()) e.currentTarget.style.backgroundColor = "#fff"; }}
//               >
//                 Confirm Reject
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default DPPApproval;











// import React, { useState, useRef, useEffect, useCallback } from "react";
// import "../DppScheduling/DppScheduling.css";
// import InputComponent from "../TestScheduling/Input-testscheduling";
// import { useLocation, useNavigate } from "react-router-dom";
// import { IoCheckmarkCircle, IoCloseCircle, IoChevronDownCircleOutline } from "react-icons/io5";
// import { FULL_API_BASE_URL } from "../../../Config/Config";

// const DPPApproval = ({ setMessageBox, setIsMessageBoxVisible, setActiveImg, dataClient }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const dashboardData = location.state || {};

//   // ── User info from dataClient (same pattern as DPPScheduleEdit) ──
//   const reviewedBy =
//     dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";

//   // ── Question Paper fields from dashboardData ──
//   const quesPaperId    = dashboardData.ques_paper_id    || dashboardData.dpp_schedule_id || null;
//   const selectedCourseName              = dashboardData.course          || "";
//   const selectedQuestionPaperSubjects   = dashboardData.subject_name    || "";
//   const selectedChapterName             = dashboardData.chapter_list    || "";
//   const selectedQuestionPaperName       = dashboardData.ques_paper_name || "";
//   const selectedQuestionPaperDescription= dashboardData.ques_paper_description || "";
//   const selectedQuestionPaperCreatedBy  = dashboardData.scheduled_by    || "";

//   // ── Data from API ──
//   const [coursePlans, setCoursePlans]         = useState([]);
//   const [instructionsHtml, setInstructionsHtml] = useState("");
//   const [existingReview, setExistingReview]   = useState(null); // { is_approved, comments }
//   const [loading, setLoading]                 = useState(true);
//   const [apiError, setApiError]               = useState("");

//   // ── Reject modal ──
//   const [rejectModal, setRejectModal]   = useState({ visible: false });
//   const [rejectComment, setRejectComment] = useState("");

//   // ── API submit state ──
//   const [submitting, setSubmitting] = useState(false);
//   const [submitError, setSubmitError] = useState("");

//   // ─────────────────────────────────────────────────────────────────────────
//   // FETCH: get-dpp-schedule-by-ques-paper-id-review
//   // ─────────────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (!quesPaperId) { setLoading(false); return; }
//     const fetchSchedules = async () => {
//       try {
//         setLoading(true);
//         const accessToken = localStorage.getItem("other");
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-dpp-schedule-by-ques-paper-id-review/?ques_paper_id=${quesPaperId}`,
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               Accept: "application/json",
//             },
//           }
//         );
//         if (!response.ok) throw new Error(`HTTP ${response.status}`);
//         const json = await response.json();

//         const schedules = json?.data?.schedule || [];
//         const reviews   = json?.data?.reviews  || [];

//         // Build folder name from dpp_level1_id > dpp_level2_id > dpp_level3_id
//         // (using their names if available, falling back to chapter_names / topic_names)
//         const plans = schedules.map((s) => {
//           const folderParts = [s.dpp_level1_name, s.dpp_level2_name, s.dpp_level3_name].filter(Boolean);
//           const folderName = folderParts.join(" > ");
//           return {
//             dpp_schedule_id: s.dpp_schedule_id,
//             dpp_name:    s.dpp_name    || "",
//             description: s.dpp_desc   || "",
//             start_date:  s.dpp_window_start || "",
//             term_date:   s.dpp_term_date    || "",
//             folder_name: folderName,
//             instructions_html: s.instructions_html || "",
//           };
//         });

//         setCoursePlans(plans);

//         // Use instructions from first schedule
//         if (schedules.length > 0) {
//           setInstructionsHtml(schedules[0].instructions_html || "");
//         }

//         // Latest review (last item)
//         if (reviews.length > 0) {
//           const latest = reviews[reviews.length - 1];
//           setExistingReview(latest);
//         }
//       } catch (err) {
//         console.error("Error fetching DPP schedules:", err);
//         setApiError("Failed to load schedule data.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchSchedules();
//   }, [quesPaperId]);

//   // ─────────────────────────────────────────────────────────────────────────
//   // SUBMIT: create-dpp-schedule-approval
//   // ─────────────────────────────────────────────────────────────────────────
//   const submitApproval = async (isApproved, comments = "") => {
//     try {
//       setSubmitting(true);
//       setSubmitError("");
//       const accessToken = localStorage.getItem("other");
//       const payload = {
//         ques_paper_id: Number(quesPaperId),
//         reviewed_by:   reviewedBy,
//         is_approved:   isApproved,
//         comments:      comments,
//       };
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/create-dpp-schedule-approval/`,
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//             Accept: "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );
//       if (!response.ok) throw new Error(`HTTP ${response.status}`);
//       // Update local review state so buttons disable/enable immediately
//       setExistingReview({ is_approved: isApproved, comments });
//       // Navigate back to dashboard on success
//       navigate("/dpp_approval_dashboard");
//     } catch (err) {
//       console.error("Error submitting approval:", err);
//       setSubmitError("Failed to submit. Please try again.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleApprove = () => {
//     submitApproval(true, "");
//   };

//   const openRejectModal = () => {
//     setRejectComment("");
//     setRejectModal({ visible: true });
//   };

//   const handleRejectConfirm = () => {
//     setRejectModal({ visible: false });
//     submitApproval(false, rejectComment);
//   };

//   const handleRejectCancel = () => {
//     setRejectModal({ visible: false });
//     setRejectComment("");
//   };

//   // Current decision derived from latest review
//   // null = never reviewed, true = approved, false = rejected
//   const currentDecision = existingReview != null ? existingReview.is_approved : null;

//   // Both buttons disabled once any decision has been made (approved or rejected)
//   const isApproveDisabled = submitting || currentDecision !== null;
//   const isRejectDisabled  = submitting || currentDecision !== null;

//   // Show comments field only when last review is rejection with a comment
//   const showCommentsField =
//     existingReview &&
//     existingReview.is_approved === false &&
//     existingReview.comments;

//   return (
//     <>
//       <div className="Leftmargin-Main-DIV">

//         {/* ── Page Header: APPROVE  REJECT  CANCEL ── */}
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px", width: "98%" }}>
//           <div style={{ fontSize: "30px", color: "var(--DppPlanNameText)", fontWeight: "400", whiteSpace: "nowrap" }}>
//             DPP Approval
//           </div>
//           <div>
//             <div className="row-cs-uni">
//               {/* APPROVE */}
//               <button
//                 className="create-test-section-btn"
//                 style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040", opacity: isApproveDisabled ? 0.45 : 1, cursor: isApproveDisabled ? "not-allowed" : "pointer" }}
//                 onClick={handleApprove}
//                 disabled={isApproveDisabled}
//               >
//                 APPROVE
//               </button>
//               {/* REJECT */}
//               <button
//                 className="create-test-section-btn"
//                 style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040", opacity: isRejectDisabled ? 0.45 : 1, cursor: isRejectDisabled ? "not-allowed" : "pointer" }}
//                 onClick={openRejectModal}
//                 disabled={isRejectDisabled}
//               >
//                 REJECT
//               </button>
//               {/* CANCEL */}
//               <button
//                 className="create-test-section-btn"
//                 style={{ marginRight: "0px", boxShadow: "0px 4px 4px 0px #00000040" }}
//                 onClick={() => navigate("/dpp_approval_dashboard")}
//                 disabled={submitting}
//               >
//                 CANCEL
//               </button>
//             </div>
//           </div>
//         </div>

//         {submitError && (
//           <div style={{ color: "#C62828", fontSize: "13px", marginBottom: "12px", width: "98%" }}>
//             {submitError}
//           </div>
//         )}

//         {/* ── QUESTION PAPER DETAIL ── */}
//         <div className="Header-1-C424342">QUESTION PAPER DETAIL</div>
//         <div className="Body-1-C424342">
//           <div className="row-cs">
//             <div className="col-cs"><InputComponent label="Select Course" style={{ width: "97%" }} value={selectedCourseName} isRequired={false} disable={true} /></div>
//             <div className="col-cs"><InputComponent label="Select Subject" style={{ width: "97%" }} value={selectedQuestionPaperSubjects} isRequired={false} disable={true} /></div>
//             <div className="col-cs"><InputComponent label="Select Chapter (Optional)" style={{ width: "97%" }} value={selectedChapterName} isRequired={false} disable={true} /></div>
//           </div>
//           <div className="row-cs">
//             <div className="col-cs"><InputComponent label="Select Topic (Optional)" style={{ width: "97%" }} value={dashboardData.topic || ""} isRequired={false} disable={true} /></div>
//             <div className="col-cs"><InputComponent label="Question Paper Name" style={{ width: "97%" }} value={selectedQuestionPaperName} isRequired={false} disable={true} /></div>
//             <div className="col-cs"><InputComponent label="Question Paper Description" style={{ width: "97%" }} value={selectedQuestionPaperDescription} isRequired={false} disable={true} /></div>
//           </div>
//           <div className="row-cs">
//             <div className="col-cs"><InputComponent label="Question Paper Created By" style={{ width: "97%" }} value={selectedQuestionPaperCreatedBy} isRequired={false} disable={true} /></div>
//             <div className="col-cs"><InputComponent label="Question Paper Subjects" style={{ width: "97%" }} value={selectedQuestionPaperSubjects} isRequired={false} disable={true} /></div>
//             <div className="col-cs" />
//           </div>

//           {/* Instructions — always shown, blank when empty */}
//           <div style={{ marginRight: "15px", marginBottom: "20px" }}>
//             <div style={{ fontSize: "13px", color: "var(--DppLabelText)", marginBottom: "6px", fontWeight: "500" }}>Instructions</div>
//             <div
//               style={{ padding: "12px 14px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", backgroundColor: "var(--DppCardBackgroundCollapsed)", fontSize: "14px", color: "var(--DppPlanNameText)", minHeight: "200px", opacity: 0.85, boxSizing: "border-box" }}
//               dangerouslySetInnerHTML={{ __html: instructionsHtml }}
//             />
//           </div>

//           {/* Comments field — only shown when last review is rejected AND has comments */}
//           {showCommentsField && (
//             <div style={{ marginRight: "15px", marginBottom: "20px" }}>
//               <div style={{ fontSize: "13px", color: "var(--DppLabelText)", marginBottom: "6px", fontWeight: "500" }}>
//                 Previous Rejection Comments
//               </div>
//               <div
//                 style={{ padding: "12px 14px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", backgroundColor: "var(--DppCardBackgroundCollapsed)", fontSize: "14px", color: "var(--DppPlanNameText)", minHeight: "48px", opacity: 0.85, boxSizing: "border-box" }}
//               >
//                 {existingReview.comments}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* ── COURSE PLAN DETAILS TABLE ── */}
//         <div style={{ marginTop: "30px", width: "98%", marginBottom: "30px" }}>
//           <div style={{ fontSize: "15px", fontWeight: "600", color: "var(--DppPlanNameText)", marginBottom: "16px" }}>
//             COURSE PLAN DETAILS
//           </div>

//           {loading ? (
//             <div style={{ padding: "40px", textAlign: "center", color: "var(--DppLabelText)", fontSize: "14px" }}>
//               Loading schedules...
//             </div>
//           ) : apiError ? (
//             <div style={{ padding: "20px", color: "#C62828", fontSize: "14px" }}>{apiError}</div>
//           ) : (
//             <div style={{ border: "1px solid var(--DppCardBorder)", borderRadius: "8px", overflow: "visible", boxShadow: "0px 2px 4px rgba(0,0,0,0.08)" }}>
//               <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                 <thead>
//                   <tr style={{ backgroundColor: "var(--DppCardHeaderExpanded)" }}>
//                     {["DPP Name", "Description", "Start Date", "Term Date", "Folder Name"].map((heading) => (
//                       <th key={heading} style={{ padding: "12px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "var(--DppLabelText)", whiteSpace: "nowrap", borderBottom: "1px solid var(--DppCardHeaderBorder)" }}>
//                         {heading}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {coursePlans.map((plan, idx) => (
//                     <tr
//                       key={plan.dpp_schedule_id}
//                       style={{ backgroundColor: idx % 2 === 0 ? "var(--DppCardBackground)" : "var(--DppCardBackgroundCollapsed)", borderBottom: "1px solid var(--DppCardBorder)" }}
//                     >
//                       <td style={{ padding: "14px 16px", fontSize: "14px", color: "var(--DppPlanNameText)", fontWeight: "500", maxWidth: "180px" }}>{plan.dpp_name}</td>
//                       <td style={{ padding: "14px 16px", fontSize: "13px", color: "var(--DppValueText)", maxWidth: "200px" }}>{plan.description}</td>
//                       <td style={{ padding: "14px 16px", fontSize: "13px", color: "var(--DppValueText)", whiteSpace: "nowrap" }}>{plan.start_date}</td>
//                       <td style={{ padding: "14px 16px", fontSize: "13px", color: "var(--DppValueText)", whiteSpace: "nowrap" }}>{plan.term_date}</td>
//                       <td style={{ padding: "14px 16px", fontSize: "13px", color: "var(--DppValueText)" }}>{plan.folder_name}</td>
//                     </tr>
//                   ))}
//                   {coursePlans.length === 0 && (
//                     <tr>
//                       <td colSpan={5} style={{ padding: "40px", textAlign: "center", color: "var(--DppLabelText)", fontSize: "14px" }}>
//                         No course plan schedules found.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* ── Reject modal ── */}
//       {rejectModal.visible && (
//         <div
//           style={{ position: "fixed", inset: 0, zIndex: 99999, backgroundColor: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center" }}
//           onMouseDown={(e) => { if (e.target === e.currentTarget) handleRejectCancel(); }}
//         >
//           <div style={{ backgroundColor: "#fff", borderRadius: "10px", padding: "28px 32px", width: "440px", boxShadow: "0 8px 32px rgba(0,0,0,0.22)" }}>
//             <div style={{ marginBottom: "16px" }}>
//               <h3 style={{ margin: 0, fontSize: "17px", fontWeight: "600", color: "#2F2E40" }}>Comments</h3>
//             </div>
//             <p style={{ margin: "0 0 12px", fontSize: "13px", color: "#6A6A7A" }}>
//               Please provide a reason for rejection. This will be recorded against the schedule.
//             </p>
//             <textarea
//               autoFocus
//               placeholder="Enter reason for rejection..."
//               value={rejectComment}
//               onChange={(e) => setRejectComment(e.target.value)}
//               rows={4}
//               style={{ width: "100%", padding: "10px 12px", border: "1px solid #D0D0E0", borderRadius: "6px", fontSize: "14px", color: "#2F2E40", resize: "vertical", outline: "none", boxSizing: "border-box", fontFamily: "inherit" }}
//               onFocus={(e) => (e.currentTarget.style.borderColor = "#337AB7")}
//               onBlur={(e) => (e.currentTarget.style.borderColor = "#D0D0E0")}
//             />
//             <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
//               <button
//                 onClick={handleRejectCancel}
//                 style={{ padding: "8px 20px", border: "1px solid #CCCCDD", borderRadius: "6px", backgroundColor: "#fff", color: "#2F2E40", fontSize: "14px", fontWeight: "500", cursor: "pointer" }}
//                 onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F5F5F8")}
//                 onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleRejectConfirm}
//                 disabled={!rejectComment.trim()}
//                 style={{ padding: "8px 20px", border: "1px solid #CCCCDD", borderRadius: "6px", backgroundColor: "#fff", color: "#2F2E40", fontSize: "14px", fontWeight: "500", cursor: rejectComment.trim() ? "pointer" : "not-allowed", opacity: rejectComment.trim() ? 1 : 0.5 }}
//                 onMouseEnter={(e) => { if (rejectComment.trim()) e.currentTarget.style.backgroundColor = "#F5F5F8"; }}
//                 onMouseLeave={(e) => { if (rejectComment.trim()) e.currentTarget.style.backgroundColor = "#fff"; }}
//               >
//                 Confirm Reject
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default DPPApproval;





















import React, { useState, useRef, useEffect, useCallback } from "react";
import "../DppScheduling/DppScheduling.css";
import InputComponent from "../TestScheduling/Input-testscheduling";
import { useLocation, useNavigate } from "react-router-dom";
import { IoCheckmarkCircle, IoCloseCircle, IoChevronDownCircleOutline } from "react-icons/io5";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import EndPoints from "../../../Api/Endpoints";
import { GET } from "../../../Api/HttpsMethods";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";

// ─── Truncate a comma-separated list to fit within a character budget ─────────
// Cuts at the last comma boundary and appends ", ..." so it never breaks mid-word.
const truncateList = (value, maxChars = 60) => {
  if (!value) return "";
  const str = String(value);
  if (str.length <= maxChars) return str;
  const cutPoint = str.lastIndexOf(",", maxChars);
  if (cutPoint <= 0) return str.slice(0, maxChars) + "...";
  return str.slice(0, cutPoint) + ", ...";
};

const DPPApproval = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dashboardData = location.state || {};

  // ── User info ─────────────────────────────────────────────────────────────
  const reviewedBy =
    dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";

  // ── All fields received from dashboard ───────────────────────────────────
  const quesPaperId   = dashboardData.ques_paper_id || null;
  const courseId      = dashboardData.course_id     || null;

  // Read-only display values
  const selectedCourseName               = dashboardData.course          || "";
  const selectedQuestionPaperSubjects    = dashboardData.subject_name    || "";
  const selectedQuestionPaperName        = dashboardData.ques_paper_name || "";
  const selectedQuestionPaperDescription = dashboardData.ques_paper_desc || ""; // ← correct key
  const selectedQuestionPaperCreatedBy   = dashboardData.scheduled_by    || "";

  // Chapter — full for tooltip, truncated for input display
  const chapterListFull    = dashboardData.chapter_list || "";
  const chapterListDisplay = truncateList(chapterListFull);

  // Topic — full for tooltip, truncated for input display
  const topicListFull    = dashboardData.topic_list || "";
  const topicListDisplay = truncateList(topicListFull);

  // ── Data from API ─────────────────────────────────────────────────────────
  const [coursePlans, setCoursePlans]           = useState([]);
  const [instructionsHtml, setInstructionsHtml] = useState("");
  const [existingReview, setExistingReview]     = useState(null);
  const [loading, setLoading]                   = useState(true);
  const [apiError, setApiError]                 = useState("");

  // ── Reject modal ──────────────────────────────────────────────────────────
  const [rejectModal, setRejectModal]     = useState({ visible: false });
  const [rejectComment, setRejectComment] = useState("");

  // ── Submit state ──────────────────────────────────────────────────────────
  const [submitting, setSubmitting]   = useState(false);
  const [submitError, setSubmitError] = useState("");

  const [previewData, setPreviewData] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const [showOptions, setShowOptions] = useState(false);

  // ── Fetch schedule data ───────────────────────────────────────────────────
  useEffect(() => {
    if (!quesPaperId) { setLoading(false); return; }

    const fetchSchedules = async () => {
      try {
        setLoading(true);
        const accessToken = localStorage.getItem("other");
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-dpp-schedule-by-ques-paper-id-review/?ques_paper_id=${quesPaperId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              Accept: "application/json",
            },
          }
        );
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const json = await response.json();

        const schedules = json?.data?.schedule || [];
        const reviews   = json?.data?.reviews  || [];

        const plans = schedules.map((s) => {
          const folderParts = [s.dpp_level1_name, s.dpp_level2_name, s.dpp_level3_name].filter(Boolean);
          return {
            dpp_schedule_id:   s.dpp_schedule_id,
            dpp_name:          s.dpp_name    || "",
            description:       s.dpp_desc   || "",
            start_date:        s.dpp_window_start || "",
            term_date:         s.dpp_term_date    || "",
            folder_name:       folderParts.join(" > "),
            instructions_html: s.instructions_html || "",
          };
        });

        setCoursePlans(plans);

        if (schedules.length > 0) {
          setInstructionsHtml(schedules[0].instructions_html || "");
        }

        // Latest review is the last item in the array
        if (reviews.length > 0) {
          setExistingReview(reviews[reviews.length - 1]);
        }
      } catch (err) {
        console.error("Error fetching DPP schedules:", err);
        setApiError("Failed to load schedule data.");
      } finally {
        setLoading(false);
      }
    };

    fetchSchedules();
  }, [quesPaperId]);

  // ── Submit approval / rejection ───────────────────────────────────────────
  const submitApproval = async (isApproved, comments = "") => {
    try {
      setSubmitting(true);
      setSubmitError("");
      const accessToken = localStorage.getItem("other");
      const payload = {
        ques_paper_id: Number(quesPaperId),
        reviewed_by:   reviewedBy,
        is_approved:   isApproved,
        comments:      comments,
      };
      const response = await fetch(
        `${FULL_API_BASE_URL}/create-dpp-schedule-approval/`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      setExistingReview({ is_approved: isApproved, comments });
      navigate("/dpp_approval_dashboard");
    } catch (err) {
      console.error("Error submitting approval:", err);
      setSubmitError("Failed to submit. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleApprove = () => submitApproval(true, "");

  const handlePreview = async () => {
    if (!quesPaperId) return;
    const previewUrl = `${EndPoints.PRISM_GET_FULL_QUESTION_PAPER_FOR_DPP_BY_QUES_PAPER_AND_SET}?ques_paper_id=${quesPaperId}`;

    setPreviewLoading(true);
    try {
      const result = await GET.withToken(previewUrl, { setMessageBox, setIsMessageBoxVisible, setActiveImg });
      if (result?.status === 200) {
        setPreviewData({
          ques_paper_info: result.ques_paper_info,
          subjects: result.subjects,
        });
        setShowPreviewPopup(true);
      } else {
        setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><span>{result?.message || "Failed to load preview."}</span></div></div>);
        setIsMessageBoxVisible(true);
      }
    } catch (e) {
      console.error("Preview error:", e);
    } finally {
      setPreviewLoading(false);
    }
  };

  const openRejectModal = () => {
    setRejectComment("");
    setRejectModal({ visible: true });
  };

  const handleRejectConfirm = () => {
    setRejectModal({ visible: false });
    submitApproval(false, rejectComment);
  };

  const handleRejectCancel = () => {
    setRejectModal({ visible: false });
    setRejectComment("");
  };

  // Once any decision has been made, both buttons are disabled
  const currentDecision    = existingReview != null ? existingReview.is_approved : null;
  const isApproveDisabled  = submitting || currentDecision !== null;
  const isRejectDisabled   = submitting || currentDecision !== null;

  // Show prior rejection comment if the last review was a rejection with a comment
  const showCommentsField =
    existingReview &&
    existingReview.is_approved === false &&
    existingReview.comments;

  return (
    <>
      <div className="Leftmargin-Main-DIV">

        {/* ── Page Header ── */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px", width: "98%" }}>
          <div style={{ fontSize: "30px", color: "var(--DppPlanNameText)", fontWeight: "400", whiteSpace: "nowrap" }}>
            DPP Approval
          </div>
          <div>
            <div className="row-cs-uni">
              <button
                className="create-test-section-btn"
                style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040", opacity: isApproveDisabled ? 0.45 : 1, cursor: isApproveDisabled ? "not-allowed" : "pointer" }}
                onClick={handleApprove}
                disabled={isApproveDisabled}
              >
                APPROVE
              </button>
              <button
                className="create-test-section-btn"
                style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040", opacity: isRejectDisabled ? 0.45 : 1, cursor: isRejectDisabled ? "not-allowed" : "pointer" }}
                onClick={openRejectModal}
                disabled={isRejectDisabled}
              >
                REJECT
              </button>
              <button
                className="create-test-section-btn"
                style={{ marginRight: "18px", boxShadow: "0px 4px 4px 0px #00000040" }}
                onClick={() => navigate("/dpp_approval_dashboard")}
                disabled={submitting}
              >
                CANCEL
              </button>
              <button
                className="create-test-section-btn"
                style={{ marginRight: "0px", boxShadow: "0px 4px 4px 0px #00000040", opacity: previewLoading ? 0.6 : 1, cursor: previewLoading ? "wait" : "pointer" }}
                onClick={!previewLoading ? handlePreview : undefined}
                disabled={previewLoading}
              >
                {previewLoading ? "LOADING..." : "PREVIEW"}
              </button>
            </div>
          </div>
        </div>

        {submitError && (
          <div style={{ color: "#C62828", fontSize: "13px", marginBottom: "12px", width: "98%" }}>
            {submitError}
          </div>
        )}

        {/* ── QUESTION PAPER DETAIL ── */}
        <div className="Header-1-C424342">QUESTION PAPER DETAIL</div>
        <div className="Body-1-C424342">

          {/* Row 1: Course, Subject, Chapter */}
          <div className="row-cs">
            <div className="col-cs">
              <InputComponent
                label="Select Course"
                style={{ width: "97%" }}
                value={selectedCourseName}
                isRequired={false}
                disable={true}
              />
            </div>
            <div className="col-cs">
              <InputComponent
                label="Select Subject"
                style={{ width: "97%" }}
                value={selectedQuestionPaperSubjects}
                isRequired={false}
                disable={true}
              />
            </div>
            <div className="col-cs">
              {/* Full chapter list shown on hover via title */}
              <div title={chapterListFull || undefined}>
                <InputComponent
                  label="Select Chapter (Optional)"
                  style={{ width: "97%" }}
                  value={chapterListDisplay}
                  isRequired={false}
                  disable={true}
                />
              </div>
            </div>
          </div>

          {/* Row 2: Topic, Question Paper Name, Description */}
          <div className="row-cs">
            <div className="col-cs">
              {/* Full topic list shown on hover via title */}
              <div title={topicListFull || undefined}>
                <InputComponent
                  label="Select Topic (Optional)"
                  style={{ width: "97%" }}
                  value={topicListDisplay}
                  isRequired={false}
                  disable={true}
                />
              </div>
            </div>
            <div className="col-cs">
              <InputComponent
                label="Question Paper Name"
                style={{ width: "97%" }}
                value={selectedQuestionPaperName}
                isRequired={false}
                disable={true}
              />
            </div>
            <div className="col-cs">
              <InputComponent
                label="Question Paper Description"
                style={{ width: "97%" }}
                value={selectedQuestionPaperDescription}
                isRequired={false}
                disable={true}
              />
            </div>
          </div>

          {/* Row 3: Created By, Subjects, empty */}
          <div className="row-cs">
            <div className="col-cs">
              <InputComponent
                label="Question Paper Created By"
                style={{ width: "97%" }}
                value={selectedQuestionPaperCreatedBy}
                isRequired={false}
                disable={true}
              />
            </div>
            <div className="col-cs">
              <InputComponent
                label="Question Paper Subjects"
                style={{ width: "97%" }}
                value={selectedQuestionPaperSubjects}
                isRequired={false}
                disable={true}
              />
            </div>
            <div className="col-cs" />
          </div>

          {/* Instructions — read-only rendered HTML */}
          <div style={{ marginRight: "15px", marginBottom: "20px" }}>
            <div style={{ fontSize: "13px", color: "var(--DppLabelText)", marginBottom: "6px", fontWeight: "500" }}>
              Instructions
            </div>
            <div
              style={{ padding: "12px 14px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", backgroundColor: "var(--DppCardBackgroundCollapsed)", fontSize: "14px", color: "var(--DppPlanNameText)", minHeight: "200px", opacity: 0.85, boxSizing: "border-box" }}
              dangerouslySetInnerHTML={{ __html: instructionsHtml }}
            />
          </div>

          {/* Prior rejection comment — only shown when last review was a rejection */}
          {showCommentsField && (
            <div style={{ marginRight: "15px", marginBottom: "20px" }}>
              <div style={{ fontSize: "13px", color: "var(--DppLabelText)", marginBottom: "6px", fontWeight: "500" }}>
                Previous Rejection Comments
              </div>
              <div style={{ padding: "12px 14px", border: "1px solid var(--DppInputBorder)", borderRadius: "4px", backgroundColor: "var(--DppCardBackgroundCollapsed)", fontSize: "14px", color: "var(--DppPlanNameText)", minHeight: "48px", opacity: 0.85, boxSizing: "border-box" }}>
                {existingReview.comments}
              </div>
            </div>
          )}
        </div>

        {/* ── COURSE PLAN DETAILS TABLE ── */}
        <div style={{ marginTop: "30px", width: "98%", marginBottom: "30px" }}>
          <div style={{ fontSize: "15px", fontWeight: "600", color: "#6A6A6A", marginBottom: "16px" }}>
            COURSE PLAN DETAILS
          </div>

          {loading ? (
            <div style={{ padding: "40px", textAlign: "center", color: "var(--DppLabelText)", fontSize: "14px" }}>
              Loading schedules...
            </div>
          ) : apiError ? (
            <div style={{ padding: "20px", color: "#C62828", fontSize: "14px" }}>{apiError}</div>
          ) : (
            <div style={{ border: "1px solid var(--DppCardBorder)", borderRadius: "8px", overflow: "visible", boxShadow: "0px 2px 4px rgba(0,0,0,0.08)" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ backgroundColor: "var(--DppCardHeaderExpanded)" }}>
                    {["DPP Name", "Description", "Start Date", "Term Date", "Folder Name"].map((heading) => (
                      <th
                        key={heading}
                        style={{ padding: "12px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "var(--DppLabelText)", whiteSpace: "nowrap", borderBottom: "1px solid var(--DppCardHeaderBorder)" }}
                      >
                        {heading}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {coursePlans.map((plan, idx) => (
                    <tr
                      key={plan.dpp_schedule_id}
                      style={{ backgroundColor: idx % 2 === 0 ? "var(--DppCardBackground)" : "var(--DppCardBackgroundCollapsed)", borderBottom: "1px solid var(--DppCardBorder)" }}
                    >
                      <td style={{ padding: "14px 16px", fontSize: "14px", color: "#6A6A6A", fontWeight: "500", maxWidth: "180px" }}>{plan.dpp_name}</td>
                      <td style={{ padding: "14px 16px", fontSize: "13px", color: "#6A6A6A", maxWidth: "200px" }}>{plan.description}</td>
                      <td style={{ padding: "14px 16px", fontSize: "13px", color: "#6A6A6A", whiteSpace: "nowrap" }}>{plan.start_date}</td>
                      <td style={{ padding: "14px 16px", fontSize: "13px", color: "#6A6A6A", whiteSpace: "nowrap" }}>{plan.term_date}</td>
                      <td style={{ padding: "14px 16px", fontSize: "13px", color: "#6A6A6A" }}>{plan.folder_name}</td>
                    </tr>
                  ))}
                  {coursePlans.length === 0 && (
                    <tr>
                      <td colSpan={5} style={{ padding: "40px", textAlign: "center", color: "var(--DppLabelText)", fontSize: "14px" }}>
                        No course plan schedules found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* ── Reject modal ── */}
      {rejectModal.visible && (
        <div
          style={{ position: "fixed", inset: 0, zIndex: 99999, backgroundColor: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center" }}
          onMouseDown={(e) => { if (e.target === e.currentTarget) handleRejectCancel(); }}
        >
          <div style={{ backgroundColor: "#fff", borderRadius: "10px", padding: "28px 32px", width: "440px", boxShadow: "0 8px 32px rgba(0,0,0,0.22)" }}>
            <div style={{ marginBottom: "16px" }}>
              <h3 style={{ margin: 0, fontSize: "17px", fontWeight: "600", color: "#2F2E40" }}>Comments</h3>
            </div>
            <p style={{ margin: "0 0 12px", fontSize: "13px", color: "#6A6A7A" }}>
              Please provide a reason for rejection. This will be recorded against the schedule.
            </p>
            <textarea
              autoFocus
              placeholder="Enter reason for rejection..."
              value={rejectComment}
              onChange={(e) => setRejectComment(e.target.value)}
              rows={4}
              style={{ width: "100%", padding: "10px 12px", border: "1px solid #D0D0E0", borderRadius: "6px", fontSize: "14px", color: "#2F2E40", resize: "vertical", outline: "none", boxSizing: "border-box", fontFamily: "inherit" }}
              onFocus={(e) => (e.currentTarget.style.borderColor = "#337AB7")}
              onBlur={(e) => (e.currentTarget.style.borderColor = "#D0D0E0")}
            />
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
              <button
                onClick={handleRejectCancel}
                style={{ padding: "8px 20px", border: "1px solid #CCCCDD", borderRadius: "6px", backgroundColor: "#fff", color: "#2F2E40", fontSize: "14px", fontWeight: "500", cursor: "pointer" }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F5F5F8")}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
              >
                Cancel
              </button>
              <button
                onClick={handleRejectConfirm}
                disabled={!rejectComment.trim()}
                style={{ padding: "8px 20px", border: "1px solid #CCCCDD", borderRadius: "6px", backgroundColor: "#fff", color: "#2F2E40", fontSize: "14px", fontWeight: "500", cursor: rejectComment.trim() ? "pointer" : "not-allowed", opacity: rejectComment.trim() ? 1 : 0.5 }}
                onMouseEnter={(e) => { if (rejectComment.trim()) e.currentTarget.style.backgroundColor = "#F5F5F8"; }}
                onMouseLeave={(e) => { if (rejectComment.trim()) e.currentTarget.style.backgroundColor = "#fff"; }}
              >
                Confirm Reject
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Preview Popup ── */}
      {showPreviewPopup && previewData && (
        <div
          style={{
            position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)", zIndex: 99999,
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
          onClick={() => setShowPreviewPopup(false)}
        >
          <button
            onClick={(e) => { e.stopPropagation(); setShowPreviewPopup(false); }}
            style={{
              position: "absolute", top: "20px", right: "20px",
              background: "white", border: "1px solid #ccc", borderRadius: "50%",
              width: "36px", height: "36px", fontSize: "20px", cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: "#666", fontWeight: "bold", zIndex: 100000,
            }}
          >
            ×
          </button>

          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "60vw", height: "80vh", backgroundColor: "#fff",
              borderRadius: "8px", display: "flex", flexDirection: "column",
              overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            }}
          >
            {/* Fixed Header */}
            <div style={{
              position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 2,
              padding: "16px 20px", borderBottom: "1px solid #ccc",
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h3 style={{ margin: 0, color: "rgb(106, 106, 106)" }}>
                  Preview Question Paper
                  <span
                    style={{ marginLeft: "10px", cursor: "pointer", fontSize: "12px", textDecoration: "underline" }}
                    onClick={() => setShowOptions((prev) => !prev)}
                  >
                    {showOptions ? "Hide Options" : "Show Options"}
                  </span>
                </h3>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginTop: "10px", fontSize: "14px" }}>
                <div style={{ flex: "0 0 48%" }}>
                  <p style={{ marginBottom: "8px" }}><span>Question Paper:</span> {previewData.ques_paper_info?.ques_paper_name || selectedQuestionPaperName || "N/A"}</p>
                  <p><span>Course:</span> {selectedCourseName || "N/A"}</p>
                </div>
                <div style={{ flex: "0 0 48%" }}>
                  <p style={{ marginBottom: "8px" }}><span>Created By:</span> {selectedQuestionPaperCreatedBy || "N/A"}</p>
                  <p><span>Subjects:</span> {selectedQuestionPaperSubjects || "N/A"}</p>
                </div>
              </div>
            </div>

            {/* Scrollable Content */}
            <div style={{ overflowY: "auto", padding: "20px", flex: 1 }}>
              {previewData.subjects?.map((subject, subjIdx) => (
                <div key={subject.subject_superset_id || subjIdx} style={{ marginBottom: "24px" }}>
                  <h4 style={{ color: "#424242", marginBottom: "12px", padding: "8px 12px", textAlign: "left" }}>
                    {subject.subject_superset_name || `Subject ${subjIdx + 1}`}
                  </h4>

                  {subject.sections?.map((section, secIdx) => (
                    <div key={section.section_name || secIdx} style={{ marginBottom: "16px", paddingLeft: "12px" }}>
                      <h5 style={{ color: "rgb(106, 106, 106)", marginBottom: "18px", textAlign: "left" }}>
                        Section {section.section_name}
                      </h5>

                      {section.questions?.length > 0 ? (
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          {section.questions.map((ques, qIdx) => (
                            <li key={ques.ques_id || qIdx} style={{ marginBottom: "16px", paddingLeft: "8px" }}>
                              <div style={{ marginBottom: "4px", fontSize: "14px", color: "#424242" }}>
                                {qIdx + 1}.{" "}
                                {(() => {
                                  const raw = ques.ques_text || ques.question_text || "";
                                  const decoded = he.decode(raw);
                                  const segments = decoded.split(/(imgsrc=[^\s]+)/g);
                                  return segments.map((seg, i) => {
                                    if (seg.startsWith("imgsrc=")) {
                                      const url = seg.replace("imgsrc=", "");
                                      return <img key={i} src={url} alt={`Q${qIdx + 1}`} style={{ maxHeight: "100px", width: "auto", margin: "5px", verticalAlign: "middle" }} />;
                                    }
                                    return <span key={i}><Latex>{seg}</Latex></span>;
                                  });
                                })()}
                              </div>

                              {showOptions && ques.options?.length > 0 && (
                                <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", paddingLeft: "20px", marginTop: "5px" }}>
                                  {[0, 1].map((col) => (
                                    <ul key={col} style={{ flex: "1 1 45%", paddingLeft: "20px", listStyleType: "disc" }}>
                                      {ques.options
                                        .filter((_, idx) => idx % 2 === col)
                                        .map((option, idx) => {
                                          const globalIndex = col + idx * 2;
                                          return (
                                            <li key={option.option_id || globalIndex} style={{ padding: "4px 0", fontSize: "13px", color: "#555" }}>
                                              {String.fromCharCode(65 + globalIndex).toLowerCase()}.{" "}
                                              {(() => {
                                                const raw = option.option_text || "";
                                                const decoded = he.decode(raw);
                                                const segments = decoded.split(/(imgsrc=[^\s]+)/g);
                                                return segments.map((seg, i) => {
                                                  if (seg.startsWith("imgsrc=")) {
                                                    const url = seg.replace("imgsrc=", "");
                                                    return <img key={i} src={url} alt="option" style={{ maxHeight: "80px", width: "auto", margin: "3px", verticalAlign: "middle" }} />;
                                                  }
                                                  return <span key={i}><Latex>{seg}</Latex></span>;
                                                });
                                              })()}
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  ))}
                                </div>
                              )}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p style={{ color: "#999", fontSize: "13px" }}>No questions in this section.</p>
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default DPPApproval;